const logo = require("assets/img/logo.svg").default;
const placeholder = require("assets/img/placeholder_immagine.png").default;

const images = { logo, placeholder };

export default images;
